module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/except-mobile_d08e21.gif";